import { DropdownModel } from '@shared-features/models/dropdown-model';
import { RCustomerLookupEntityType } from '@shared-features/enums/RCustomer-lookup-entity-type.enum';
import { Expose } from 'class-transformer';
import { FleetClassification } from '@shared-features/enums/fleet-classification.enum';
import { OrderType } from '@features/orders/enums/order-type.enum';
import { DefinitionOrderTemperatureControl } from '@shared/enums/definition-order-temperature-control.enum';
import { UserInvoiceType } from '@shared-features/enums/user-invoice-type.enum';
import { CustomerType } from '@shared/enums/customer-type.enum';

export class Lookup extends DropdownModel {
  @Expose() id: number;
  @Expose() value: string;

  // extra props
  @Expose() cityId?: number;

  // extra props for r customers lookup in add shipment
  @Expose()
  type?: RCustomerLookupEntityType;

  @Expose()
  isdefault?: boolean; // IF TRUE THEN THE FLEET IS FREELANCER

  @Expose()
  sku?: string; // FOR PRODUCT TYPE ITEMs
  @Expose()
  notes?: string; // FOR PRODUCT TYPE ITEMs

  @Expose()
  productTypeName?: string;

  @Expose()
  classification?: FleetClassification;

  @Expose()
  productTypeId?: number;

  @Expose() numofpallets?: number;

  @Expose() get dropDownDisplayName(): string {
    return this.value;
  }

  @Expose() get dropDownValue(): Lookup {
    return this;
  }

  // for order lookup and it will removed when we handle return the full object of lookup
  @Expose() dropOffLocationTitle?: string;
  @Expose() dropOffLocationId?: number;
  @Expose() isPalletDetails?: boolean;
  @Expose() noOfItems?: number;
  @Expose() noOfPallets?: number;
  @Expose() orderType?: OrderType;
  @Expose() priority?: number;
  @Expose() reference?: string;
  @Expose() remainingQuantity?: number;
  @Expose() rush?: boolean;
  @Expose() sealNumber?: number;
  @Expose() temperatureControl?: DefinitionOrderTemperatureControl;
  @Expose() createdAt?: Date;
  @Expose({ name: 'customerinvoicetype' })
  customerInvoiceType?: UserInvoiceType;
  @Expose() customerType: CustomerType
}
